<div class="confirm-modal ig-modal source-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">Set Place Source</div>

        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    Place settings for {{account.account.userName}}
                </ng-template>
                <p>{{account.account.userName}}:</p>

                <ig-row>
                    <ig-spinner *ngIf="loading"></ig-spinner>
                    <ig-col [xs]="12" [md]="6" *ngIf="!loading">

                        <mat-radio-group class="radio-group" [(ngModel)]="placeSource"
                            (ngModelChange)="setPlaceSource()">
                            <mat-radio-button [value]="'facebook'">
                                Facebook
                            </mat-radio-button>
                            <mat-radio-button [value]="'google'">
                                Google
                            </mat-radio-button>
                        </mat-radio-group>

                    </ig-col>
                </ig-row>

                <ig-row *ngIf="placeSource==='google'">
                    <p *ngIf="!isUseIgDefaultCustomPlaceCategories">This client uses custom place categories, so the
                        business type here is disabled</p>
                    <ig-col [xs]="12" [md]="6">
                        <mat-form-field>
                            <mat-select [(ngModel)]="businessType" [disabled]="!isUseIgDefaultCustomPlaceCategories"
                                placeholder="Business type">
                                <mat-option value="normal">Normal</mat-option>
                                <mat-option value="area business">Area business</mat-option>
                                <mat-option value="local secrets">Local secrets</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <ig-button [disabled]="!isUseIgDefaultCustomPlaceCategories" style="width: 138px" size="md"
                            [isAsync]="true" (trigger)="setBusinessType($event)">
                            save
                        </ig-button>
                    </ig-col>
                </ig-row>

                <ig-row *ngIf="placeSource==='google'">
                    <ig-col [xs]="12" [md]="6">
                        Place images to be shown: {{showPlaceImageCount}}
                        <mat-slider class="full-width" [(ngModel)]="showPlaceImageCount" thumbLabel tickInterval="1"
                            step="1" min="1" max="10"></mat-slider>
                        <ig-button style="width: 138px" size="md" [isAsync]="true"
                            (trigger)="savePlaceImagesCount($event)">
                            save
                        </ig-button>
                    </ig-col>
                </ig-row>

                <ig-row *ngIf="placeSource==='google'">
                    <hr>
                    <div class="text-left">Please set the Google Appkey for this client, so that we can track the usage
                        for this client</div>
                    <ig-col [xs]="12" [md]="12">
                        <ig-field label="Google Appkey" [maxValue]="30" [formControl]="formGroup.get('googleKey')"
                            [(ngModel)]="googleKey">
                        </ig-field>

                    </ig-col>
                    <ig-col [xs]="12" [md]="3">
                        <ig-button size="md" (trigger)="saveGoogleKey($event)">
                            save
                        </ig-button>
                    </ig-col>
                </ig-row>

                <ig-row *ngIf="placeSource==='google'">
                    <ig-col [xs]="12" [md]="6">
                        Set nearby places default range: {{nearbyPlacesDefaultRange}}
                        <mat-slider class="full-width" [(ngModel)]="nearbyPlacesDefaultRange" thumbLabel tickInterval="1"
                            step="1" min="1" max="10"></mat-slider>
                        <ig-button style="width: 138px" size="md" [isAsync]="true"
                            (trigger)="saveNearbyPlacesDefaultRange($event)">
                            save
                        </ig-button>
                    </ig-col>
                </ig-row>

            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Place settings all accounts
                </ng-template>
                <ig-spinner *ngIf="loading"></ig-spinner>

                <div *ngIf="!loading">
                    <div class="text-left m-t-1">Block Google place categories</div>
                    <ig-field label="Type the Google place categories you want to block here"
                        [formControl]="formGroup.get('blockCategories')" [(ngModel)]="blockCategories">
                    </ig-field>
                    <ig-row style="padding: 0">
                        <ig-col [xs]="12" [md]="3">
                            <ig-button size="md" (trigger)="block($event)">
                                save
                            </ig-button>
                        </ig-col>
                    </ig-row>

                    <div class="text-left m-t-5">Block Google place keywords</div>
                    <div class="text-left light-gray-text">Type the keywords you want to block for places here</div>
                    <ig-multi-fields [group]="blockKeywords" label="keywords"></ig-multi-fields>
                    <ig-row style="padding: 0">
                        <ig-col [xs]="12" [md]="3">
                            <ig-button size="md" (trigger)="blockPlaceKeywords($event)">
                                save
                            </ig-button>
                        </ig-col>
                    </ig-row>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.place.source/set.place.source.modal.component.html